import { Box, Typography } from "@mui/material";
import { MainContainer } from "../../../components/container/MainContainer";
import { PageTitleContainer } from "../../../components/container/PageTitleContainer";
import { useTranslation } from "react-i18next";
import PrebuiltTemplate from "./PrebuiltTemplate";

const PrebuiltTemplatePage = () => {
  const { t } = useTranslation();
  return (
    <MainContainer>
      {/* Header logic moved to global Header.js */}
      <PrebuiltTemplate />
    </MainContainer>
  );
};

export default PrebuiltTemplatePage;
